export default "__VITE_ASSET__2ujAi0uH__"